import { PlusIcon } from "@heroicons/react/24/outline";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import DisplayPageForm from "src/components/PageForm/DisplayPageForm";
import Button from "src/components/Shared/Buttons/Button";
import NoData from "src/components/Shared/NoData/NoData";
import { H3 } from "src/components/Shared/Text/Headers";
import { classNames } from "src/helpers/classNames";

const NestedPageContent = ({ newPage = {}, pages = [], setNewPage = () => {}, onDragEnd = () => {}, onAddPage = () => {}, onUpdatePage = () => {}, onRemovePage = () => {} }) => {
  const nestedPages = Array.isArray(newPage.nested_pages) ? newPage.nested_pages : [];

  return (
    <div>
      <div className="flex justify-between items-end">
        <H3>Nested Pages</H3>
        <div className="mb-2">
          <Button
            version="gray"
            onClick={onAddPage}>
            <PlusIcon className="h-4 w-4 stroke-[3px]" />
            Add page
          </Button>
        </div>
      </div>
      <div className="border border-gray-20 rounded py-2 px-5">
        {/* Nested Pages */}
        <div className="space-y-8 mt-3 mb-8">
          {newPage?.nested_pages?.length === 0 ? (
            <NoData />
          ) : (
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable">
                {(provided) => (
                  <div
                    className={classNames(newPage?.nested_pages?.length > 1 ? "space-y-4" : "")}
                    {...provided.droppableProps}
                    ref={provided.innerRef}>
                    {nestedPages.map((page, i) => (
                      <Draggable
                        key={page?.id}
                        draggableId={page?.id}
                        index={i}>
                        {(provided) => (
                          <DisplayPageForm
                            className={"!left-0"}
                            permission={page}
                            setPermission={(e) => onUpdatePage(e, i)}
                            pageOptions={pages}
                            removePermission={() => onRemovePage(i)}
                            innerRef={provided.innerRef}
                            draggableProps={provided.draggableProps}
                            dragHandleProps={provided.dragHandleProps}
                            showNestedData={false}
                          />
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          )}
        </div>
      </div>
    </div>
  );
};

export default NestedPageContent;
